/**
 * Generates a string to be used as a "data-intercom-target" data attribute
 * by joining the provided parts with dots - used to target specific elements in Intercom.
 *
 * @param parts - parts of the intercom target, which will be joined with dots.
 * Each part will be converted to a string, lowercased, and non-alphanumeric characters will be replaced with hyphens.
 *
 * @returns the generated intercom target string.
 */

export function intercomTarget(...parts: Array<string | number | undefined | null>): string {
  return parts
    .filter(Boolean) // filter out initial falsy values (undefined, null, empty string)
    .map(
      (p) =>
        String(p)
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-') // Replace any sequence of non-alphanumeric characters with a single hyphen
          .replace(/^-|-$/g, ''), // Remove any leading or trailing hyphens
    )
    .filter(Boolean) // filter out any empty strings after formatting
    .join('.');
}
